<template>
    <div class="screen2">
        <div class="title">高级选项</div>
        <div class="list" ref="listBox">
            <screen3 title="规格" :list="packaging_list" :show="checkList.packaging" @checked="checked"
                @change="change_screen" type="packaging" />
            <screen3 title="交期" :list="deliveryTimeStatus_list" :show="checkList.deliveryTimeStatus" @checked="checked"
                @change="change_screen" type="deliveryTimeStatus" />
            <screen3 title="价格" :list="price_list" :show="checkList.price" @checked="checked" @change="change_screen"
                type="price" :banCheckbox="true" />
            <screen3 title="所属商家" :list="store_list" :show="checkList.storeIdArray" @checked="checked"
                @change="change_screen" type="storeIdArray" />
            <screen3 title="包装材料" :list="goodsPackage_list" :show="checkList.goodsPackage" @checked="checked"
                @change="change_screen" type="goodsPackage" />
            <screen3 title="级别" :list="packagingNew_list" :show="checkList.packagingNew" @checked="checked"
                @change="change_screen" type="packagingNew" />

            <!-- <div class="item" :class="type == 'packaging' ? 'item-checked' : ''" @click="change_screen('packaging')">包装<img src="../../assets/arrow  down@2x.png" alt="" /></div>
            <div class="item" :class="type == 'deliveryTimeStatus' ? 'item-checked' : ''" @click="change_screen('deliveryTimeStatus')">交期<img src="../../assets/arrow  down@2x.png" alt="" /></div>
            <div class="item" :class="type == 'price' ? 'item-checked' : ''" @click="change_screen('price')">价格<img src="../../assets/arrow  down@2x.png" alt="" /></div>
            <div class="item" :class="type == 'merchant' ? 'item-checked' : ''" @click="change_screen('merchant')">所属商家<img src="../../assets/arrow  down@2x.png" alt="" /></div> -->
        </div>
        <!-- <div :class="isCheckbox ? 'secondary-list2' : 'secondary-list1'" v-if="type != ''">
            <div class="all item1" v-if="!isCheckbox">
                全部
            </div>
            <div v-for="(item, index) in list" :key="index" :class="isChecked({ item, index }) ? 'item2' : 'item1'" @click="checked(all)">
                {{ item.name }}
            </div>
            <div class="button checkbox" @click="isCheckbox = !isCheckbox" v-if="list.length > 1">+多选</div>
        </div> -->
    </div>
</template>

<script>
import screen3 from './screen2_2';
export default {
    components: {
        screen3
    },
    props: ['title', 'list'],
    data() {
        return {
            all: {
                item: {
                    name: '全部',
                    id: 'all'
                },
                index: ''
            },
            isCheckbox: false, //是否是多选
            list: [],
            packaging_list: [], //包装
            deliveryTimeStatus_list: [], //交期
            price_list: [], //价格
            store_list: [], //商铺
            goodsPackage_list: [], //包装材料
            packagingNew_list: [], //级别
            checkList: {
                packaging: false,
                deliveryTimeStatus: false,
                price: false,
                storeIdArray: false,
                goodsPackage: false,
                packagingNew: false
            }

            // type: ''
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.get_goods_type_pack();
            this.get_goods_type_delivery();
            this.get_goods_type_price();
            this.get_goods_type_storeIdArray();
            this.get_goods_type_goodsPackage();
            this.get_goods_type_packagingNew();
        },
        change_screen(type) {
            if (this.checkList[type]) {
                this.$set(this.checkList, type, false);
            } else {
                this.$set(this.checkList, 'packaging', false);
                this.$set(this.checkList, 'deliveryTimeStatus', false);
                this.$set(this.checkList, 'price', false);
                this.$set(this.checkList, 'storeIdArray', false);
                this.$set(this.checkList, 'goodsPackage', false);

                this.$set(this.checkList, 'packagingNew', false);

                this.$set(this.checkList, type, true);
            }
            console.log(this.checkList);
        },
        checked(e, type) {
            this.$emit('checked', e, type);
            console.log(e, type);
        },
        // 包装
        get_goods_type_pack(e) {
            this.api.get_goods_type_pack().then(res => {
                let array = JSON.parse(res.data.description);
                this.packaging_list = [];
                array.forEach(element => {
                    this.packaging_list.push({
                        name: element,
                        id: element
                    });
                });
            });
        },

        // 交期
        get_goods_type_delivery(e) {
            // this.api.get_goods_type_delivery().then(res => {
            //     let array = JSON.parse(res.data.description);
            //     this.deliveryTimeStatus_list = [];
            //     array.forEach(element => {
            //         if (element == 0) {
            //             this.deliveryTimeStatus_list.push({
            //                 name: '现货',
            //                 id: element
            //             });
            //         } else {
            //             this.deliveryTimeStatus_list.push({
            //                 name: element + '天',
            //                 id: element
            //             });
            //         }
            //     });
            // });
            this.deliveryTimeStatus_list = [
                {
                    name: '现货',
                    id: '现货'
                },
                {
                    name: '期货',
                    id: '期货'
                }
            ];
        },

        // 价格
        get_goods_type_price(e) {
            this.api.get_goods_type_price().then(res => {
                let array = JSON.parse(res.data.description);
                this.price_list = [];
                console.log(array);
                array.forEach(element => {
                    this.price_list.push({
                        name: `￥${element.min}-￥${element.max}`,
                        id: element
                    });
                });
            });
        },
        //商家
        get_goods_type_storeIdArray() {
            this.api.get_goods_type_storeIdArray().then(res => {
                let array = res.data;
                this.store_list = [];
                array.forEach(element => {
                    this.store_list.push({
                        name: element.name,
                        id: element.uuid
                    });
                });
            });
        },
        //级别
        get_goods_type_packagingNew() {
            this.api.get_goods_type_packagingNew().then(res => {
                console.log(res, '级别级别');
                this.packagingNew_list = res.data
                // let array = JSON.parse(res.data.description);
                // this.packagingNew_list = [];
                // array.forEach(element => {
                //     this.packagingNew_list.push({
                //         name: element,
                //         id: element
                //     });
                // });
            });
        },
        //包装材料
        get_goods_type_goodsPackage() {
            this.api.get_goods_type_goodsPackage().then(res => {
                let array = JSON.parse(res.data.description);
                this.goodsPackage_list = [];
                array.forEach(element => {
                    this.goodsPackage_list.push({
                        name: element,
                        id: element
                    });
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.screen2 {
    display: flex;
    border-bottom: 1px solid #ede9e9;
    position: relative;

    .title {
        width: 100px;
        padding: 7px 24px 7px 0;
        background: #f4f4f4;
        text-align: right;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 24px;
        flex-shrink: 0;
    }

    .list {
        flex-wrap: wrap;
        display: flex;
        padding: 10px 120px 0 10px;
        width: 1100px;

        // position: relative;
        .item {
            margin-right: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            padding: 0 7px;
            border: 1px solid #ede9e9;

            &:hover {
                color: #2b9a34;
            }

            cursor: default;

            img {
                width: 9px;
                height: 5px;
                margin: auto 0 auto 5px;
            }

            color: #333333;

            &-checked {
                position: relative;
                z-index: 1;
                background: #ffffff;
                border: 1px solid #2b9a34;
                border-bottom: 0;
            }
        }
    }

    .secondary-list1 {
        display: flex;
        position: absolute;
        top: 31px;
        width: 1200px;
        background: #ffffff;
        border: 1px solid #6e6e6e;
        padding: 15px 72px 0 20px;
        background: #ffffff;
        flex-wrap: wrap;

        .item1,
        .item2 {
            margin-right: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            cursor: default;
        }

        .item1 {
            color: #333333;
        }

        .item2 {
            color: #2b9a34;
        }

        .checkbox {
            position: absolute;
            top: 10px;
            right: 12px;
            width: 50px;
            height: 24px;
            border: 1px solid #ede9e9;
            text-align: center;
        }
    }

    .secondary-list2 {
        display: flex;
        position: absolute;
        top: 31px;
        width: 1200px;
        background: #ffffff;
        border: 1px solid #2b9a34;
        padding: 15px 72px 0 20px;
        background: #ffffff;
        flex-wrap: wrap;

        .item1,
        .item2 {
            margin-right: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            cursor: default;
            display: flex;
            align-items: center;
        }

        .item1 {
            color: #333333;
        }

        .item2 {
            color: #2b9a34;
        }

        .item1::before {
            content: '';
            display: block;
            width: 14px;
            color: #333333;

            height: 14px;
            background: #ffffff;
            border-radius: 1px;
            border: 1px solid #d9d9d9;
            margin-right: 6px;
        }

        .item2::before {
            content: '';
            display: block;

            color: #2b9a34;
            width: 14px;
            height: 14px;
            background-image: url('../../assets/checkin@2x.png');
            border-radius: 1px;
            margin-right: 6px;
            background-size: 100%;
        }

        .checkbox {
            position: absolute;
            top: 10px;
            right: 12px;
            width: 50px;
            height: 24px;
            border: 1px solid #ede9e9;
            text-align: center;
        }
    }
}

div {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/productList/screen2.vue